import { Alert, AlertDescription, AlertTitle, Flex } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const ResultPaymentPage = () => {
    const { search } = useLocation() ;
    const searchParams = new URLSearchParams(search) ;

    console.log("ResultPaymentPage");
    console.log(searchParams);

    return (
        <Flex width="100%" justifyContent="space-around">
            <Alert variant='subtle' flexDirection='column' alignItems='center' justifyContent='center' textAlign='center' height='200px' width="20%" mt="20">
                <AlertTitle mt={4} mb={1} fontSize='lg'>
                    Super je passe ici
                </AlertTitle>
                <AlertDescription maxWidth='sm'>
                    Et ça c'est la description
                </AlertDescription>
            </Alert>
        </Flex>
    ) ;
}

export default ResultPaymentPage ;